<template>
    <div>
        <TaskInformation :task-id="taskId" />

        <GeneralInformation :task-id="taskId" />

        <TaskRibbon :task-id="taskId"
                    :complete="taskBits.canComplete"
                    :redirect="taskBits.canRedirect"
                    :rework="taskBits.canRework"
                    :close="taskBits.canClose"
                    @complete="onComplete"
                    @succeed="succeeded"
                    @rework="onRework" />
    </div>
</template>
<script>
    import TasksService from '@/services/TasksService.js'
    import { ActivityDefinitionsEnum } from '@/helpers/constants/enumerations.js'

    import TaskInformation from '@/components/app/task/TaskInformation.vue'
  
    import GeneralInformation from '@/components/app/task/dynamic/GeneralInformation.vue'
    import TaskRibbon from '@/components/app/task/TaskRibbon.vue'



    export default {

        components: {
            TaskInformation,
            GeneralInformation,
            TaskRibbon,
        },

        props: {
            taskId: {
                type: Number,
                default: null
            }
        },

        data() {
            return {
                workProgramsDialog: false,
                taskBits: {
                    activityDefinitionName: null,
                    canRedirect: false,
                    canRework: false,
                    canClose: false,
                    canComplete: false,
                }
            }
        },

        computed: {
            isReviewComments() {
                return ActivityDefinitionsEnum.addComments === this.taskBits.activityDefinitionName
            },

        },

        created() {
            this.getTaskBits()
        },

        methods: {

            getTaskBits() {

                TasksService.getTaskBits(this.taskId).then(res => {
                    if (res.data != null) {
                        this.taskBits = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },


            onComplete(proceedCallBackMethod) {
                proceedCallBackMethod(null)
            },

            onRework(proceedCallBackMethod) {
                proceedCallBackMethod(null)
            },

            succeeded(success) {
                this.$emit('completed', success)
            }
        }
    }
</script>